import { useIndicationData } from 'features/indicationTriage'
import { IndicationItem } from 'features/indicationTriage/api/indicationTriageApi'
import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { DamageCategory, GeckoEntryBase, RD_TYPE_DAMAGE_AREA } from 'types'
import { v4 as uuid } from 'uuid'

export const useGetDamageCategories = (indicationItem?: IndicationItem) => {
  const {
    site,
    organization,
    component: selectedComponent,
    inspection: selectedInspection,
    unit,
  } = useIndicationData()
  const {
    entries: damageAreaEntries,
    forceRefresh,
    isLoading,
  } = useRolodexEntries({
    type: RD_TYPE_DAMAGE_AREA,
    tags: {
      indication: indicationItem?.id ?? '',
    },
    limit: 100000,
  })

  const mergedDamageCategoryEntries: GeckoEntryBase<DamageCategory>[] =
    useMemo(() => {
      const defaultDamageCategory = {
        id: uuid(),
        type: RD_TYPE_DAMAGE_AREA,
        data: {
          generated: {},
        },
        tags: {
          site: site?.id,
          organization: organization?.id,
          unit: unit?.id,
          component: selectedComponent?.id,
          inspection: selectedInspection?.id,
          indication: indicationItem?.id,
        },
      }
      //if no damage area is found, create a new one
      const damageAreas = (
        !damageAreaEntries || damageAreaEntries.length < 1
          ? [defaultDamageCategory]
          : damageAreaEntries
      ) as GeckoEntryBase<DamageCategory>[]

      //merge the generated data with the data
      return damageAreas.map((damageArea) => {
        return {
          ...damageArea,
          data: {
            ...damageArea.data.generated,
            ...damageArea.data,
            generated: {
              ...damageArea.data.generated,
            },
          },
        }
      })
    }, [
      damageAreaEntries,
      indicationItem,
      organization?.id,
      selectedComponent?.id,
      selectedInspection?.id,
      site?.id,
      unit?.id,
    ])

  return {
    damageCategoryEntries: mergedDamageCategoryEntries,
    forceRefresh,
    isLoading,
  }
}
